const dsChannel = new BroadcastChannel('cart');

const dsChannels = (($) => {

    $(document).ready(function () {
        dsChannel.onmessage = function(e) {
            const origin = doorstep.url.endsWith('/') ? doorstep.url.substr(0, doorstep.url.length - 1) : doorstep.url,
                actions = ['add', 'remove', 'clear', 'reload', 'redirect', 'logout'],
                action = e.data.action;
            if (e.origin == origin && actions.includes(action)) {
                if (action === 'logout') {
                    location.href = dsUtilities.urlLogout('crosstab');
                } else if ($('#my-box-load').length) {
                    if (action === 'redirect') {
                        location.href = e.data.redirect_to;
                    } else {
                        $('#my-box-load').load(dsCart.myBoxUrl(), function (response, status, xhr) {
                            dsCart.loadCart();
                            dsCart.cartEvents();
                            dsProduct.loadPage('products');
                            if (action === 'add') {
                                addAction(e.data.id, e.data.quantity);
                            }
                            if (action === 'remove') {
                                removeAction(e.data.id);
                            }
                            if (action === 'clear') {s
                                clearAction();
                            }
                        });
                    }
                }
            }
            return true;
        }

        function addAction(id, quantity) {
            let [show, hide] = ['div.add-deduct-item-row',  'button.add-to-cart'], count = 0;
            $('div.product-card').each(function (i, el) {
                const product = dsProduct.getProduct($(el));
                count++;
                if (product.id === id) {
                    addActionPost(id, quantity, count, 0);
                } else {
                    let child_count = 0;
                    product.child_products.forEach(function (child) {
                        child_count++;
                        if (child.id === id) {
                            addActionPost(id, quantity, count, child_count);
                        }
                    });
                }
            });
        }

        function addActionPost(id, quantity, count, child_count) {
            const card = $('div.product-card').eq(count - 1);
            const el = $(card).find('button.add-to-cart').eq(child_count);
            dsProduct.productButtonChange($(el), 'inc');
            dsProduct.updateInCart(id, quantity);
        }

        function removeAction(id) {
            dsProduct.updateInCart(id, 0);
            dsProduct.resetButtons(id);
        }

        function clearAction() {
            dsProduct.resetButtons();
        }

    });

})(jQuery);